export default __webpack_public_path__ + "static/media/pekalongan2.f28e933d.jpg";